export const MORTGAGE_PAGES = {
    "hipoteca-100": {
        icon: "Percent",
        title: "Hipoteca 100% Financiación",
        subtitle: "Compra tu vivienda sin necesidad de entrada inicial",
        intro: [
            "¿Quieres comprar una vivienda y no dispones del ahorro necesario para la entrada? Con la hipoteca al 100% de financiación, puedes acceder a una casa sin tener que aportar capital inicial. Este producto permite financiar el valor total de compraventa del inmueble, una solución ideal para quienes tienen ingresos estables pero no han podido ahorrar lo suficiente.",
            "Esta opción puede ser la clave para muchas personas, especialmente en un mercado donde los precios de la vivienda y los costes iniciales suelen ser una barrera.",
        ],
        benefitsTitle: "Ventajas de la Hipoteca al 100%",
        benefits: [
            "Financiación del 100% del valor de compraventa",
            "Opción de incluir parte de los gastos de notaría y gestoría",
            "Alternativas para personas sin ahorros iniciales",
            "Condiciones personalizadas según tu perfil financiero",
        ],
        note: {
            title: "¿Eres joven y buscas tu primera vivienda?",
            text: "También es una excelente opción para jóvenes profesionales que desean emanciparse sin necesidad de años de ahorro. Si tienes ingresos estables y proyección profesional, podemos ayudarte a conseguir tu primera casa con el mínimo desembolso.",
        },
        cta: "Solicita tu estudio gratuito y sin compromiso. Te ayudamos a saber si puedes acceder a una hipoteca 100%.",
    },
    "hipoteca-95": {
        icon: "Wallet",
        title: "Hipoteca al 95%",
        subtitle: "Aporta solo el 5% de entrada para tu nueva casa",
        intro: [
            "Con la hipoteca al 95%, puedes financiar casi el total del precio de compra de tu vivienda. Es una solución perfecta si ya tienes algo ahorrado, pero no llegas al 20% que suelen exigir los bancos.",
            "Esta modalidad se adapta tanto a compradores primerizos como a quienes desean mudarse sin descapitalizarse. Además, puede incluir opciones de financiación para algunos gastos asociados a la compra.",
        ],
        benefitsTitle: "Beneficios clave",
        benefits: [
            "Solo necesitas el 5% de entrada",
            "Cuotas mensuales ajustadas y estables",
            "Ideal para perfiles con ingresos constantes pero poco ahorro",
            "Opciones en tipos fijo, variable o mixto",
        ],
        note: {
            title: "¿Joven con trabajo estable y pocos ahorros?",
            text: "Esta opción te permite acceder a una vivienda propia con una inversión inicial mínima. Cada vez más jóvenes apuestan por esta modalidad para salir del alquiler.",
        },
        cta: "Solicita tu estudio gratuito y sin compromiso. Te ayudamos a saber si puedes acceder a tu hipoteca 95%",
    },
    "hipoteca-sin-vinculaciones": {
        icon: "Link2Off",
        title: "Hipoteca Sin Vinculaciones",
        subtitle: "Financia tu casa sin contratar productos adicionales",
        intro: [
            "La mayoría de los bancos ofrecen mejores condiciones si contratas productos como seguros, tarjetas o planes de pensiones. Pero con nuestra hipoteca sin vinculaciones, tú decides. Obtendrás financiación sin necesidad de comprometerte con productos que no deseas.",
            "Este producto está pensado para quienes buscan transparencia, independencia financiera y simplicidad.",
        ],
        benefitsTitle: "¿Por qué elegir una hipoteca sin vinculaciones?",
        benefits: [
            "No necesitas domiciliar la nómina ni contratar seguros",
            "Ahorro real a medio y largo plazo",
            "Comparativa clara de intereses sin condiciones encubiertas",
            "Total libertad para elegir tus propios proveedores de seguros o servicios",
        ],
        note: {
            title: "Libertad financiera",
            text: "Ideal para autónomos, profesionales independientes o cualquier persona que priorice la libertad financiera.",
        },
        cta: "Solicita tu estudio gratuito y sin compromiso. Te ayudamos a saber si puedes acceder a una hipoteca sin vinculaciones.",
    },
    "hipoteca-segunda-vivienda": {
        icon: "Palmtree",
        title: "Hipoteca 80% Segunda Vivienda o Inversión",
        subtitle: "Compra tu segunda casa o invierte con financiación segura",
        intro: [
            "¿Estás pensando en comprar una segunda residencia para escapadas o como inversión? Nuestra hipoteca te permite financiar hasta el 80% del valor de tasación o compraventa del inmueble.",
            "Esta opción es ideal tanto para familias que quieren una casa en la playa o la montaña, como para inversores que buscan rentabilizar su capital a través del alquiler o revalorización del inmueble.",
        ],
        benefitsTitle: "Ventajas destacadas",
        benefits: [
            "Financiación del 80% para segunda vivienda",
            "Condiciones atractivas para compra de inmuebles turísticos",
            "Opción de amortización anticipada y flexibilidad de plazos",
            "Posibilidad de incluir parte de los gastos",
        ],
        note: {
            title: "¿Joven inversor con visión a futuro?",
            text: "Algunos perfiles jóvenes con capacidad de ahorro también acceden a esta hipoteca para adquirir su primera propiedad como inversión. Perfecto si ya tienes una primera vivienda y buscas diversificar tu patrimonio.",
        },
        cta: "Solicita tu estudio gratuito y sin compromiso. Te ayudamos a saber si puedes acceder a una hipoteca del 80% para tu segunda vivienda o vivienda de inversión.",
    },
    "hipoteca-premium": {
        icon: "Gem",
        title: "Hipoteca Premium",
        subtitle: "Soluciones a medida para propiedades de alto valor",
        intro: [
            "Si estás buscando financiación para una vivienda de alto valor, te ofrecemos nuestra hipoteca Premium, diseñada para clientes con necesidades específicas y perfiles de alto nivel adquisitivo.",
            "Ofrecemos un servicio exclusivo, con asesoramiento financiero integral y condiciones negociadas directamente con las entidades.",
        ],
        benefitsTitle: "¿Qué incluye una hipoteca Premium?",
        benefits: [
            "Atención personalizada y confidencial",
            "Estudio fiscal y planificación financiera",
            "Financiación adaptada al perfil del cliente",
            "Opciones para grandes patrimonios y no residentes",
        ],
        note: {
            title: "Servicio exclusivo",
            text: "Recomendado para empresarios, directivos, expatriados y compradores de propiedades de lujo.",
        },
        cta: "Solicita tu estudio gratuito y sin compromiso. Te ayudamos a saber si puedes acceder a una hipoteca de alto valor.",
    },
    "reunificacion-deudas": {
        icon: "Layers",
        title: "Reunificación de Deudas",
        subtitle: "Junta todas tus deudas en tu hipoteca y paga una sola cuota",
        intro: [
            "¿Tienes varios préstamos personales, tarjetas de crédito o deudas con distintos intereses? La reunificación de deudas te permite unificarlos en tu hipoteca y pagar una sola cuota mensual más baja.",
            "Es una opción inteligente para recuperar estabilidad financiera, reducir tu carga mensual y evitar impagos.",
        ],
        benefitsTitle: "Beneficios de la reunificación",
        benefits: [
            "Reducción significativa de la cuota mensual",
            "Un solo pago al mes, más cómodo y predecible",
            "Mejora de tu capacidad financiera y liquidez",
            "Posibilidad de alargar el plazo para ajustar las cuotas",
        ],
        note: {
            title: "Recupera tu estabilidad",
            text: "Ideal para familias, autónomos o cualquier persona que quiera reorganizar sus finanzas sin dejar de pagar.",
        },
        cta: "Solicita tu estudio gratuito y sin compromiso. Te ayudamos a saber si podemos ayudarte a mejorar tu salud financiera.",
    },
    "hipoteca-90": {
        icon: "KeyRound",
        title: "Hipoteca 90%",
        subtitle: "Consigue más financiación para comprar tu vivienda",
        intro: [
            "¿Quieres comprar una vivienda pero no tienes el ahorro suficiente? Con una hipoteca al 90% de financiación puedes acceder a tu casa aportando solo una parte del precio, reduciendo la entrada inicial necesaria.",
            "En Keypoteca te ayudamos a encontrar las mejores opciones de hipoteca del 90%, comparando entre diferentes bancos y estudiando tu perfil para aumentar tus posibilidades de aprobación.",
        ],
        sections: [
            {
                title: "¿Qué es una hipoteca al 90%?",
                paragraphs: [
                    "Una hipoteca del 90% es aquella que permite financiar hasta el 90% del valor de compra o tasación de la vivienda, según el banco. Esto significa que el comprador solo necesita aportar aproximadamente el 10% del precio, además de los gastos asociados a la operación.",
                    "Es una solución muy interesante para personas que tienen ingresos estables pero no han podido ahorrar el 20% habitual que suelen exigir la mayoría de hipotecas.",
                ],
            },
            {
                title: "¿Para quién es una hipoteca del 90%?",
                paragraphs: ["Este tipo de financiación está pensada para:"],
                list: [
                    "Personas que compran su primera vivienda",
                    "Compradores con ingresos estables",
                    "Familias que buscan vivienda habitual",
                    "Jóvenes profesionales que quieren independizarse",
                    "Personas con ahorro parcial pero insuficiente para la entrada completa",
                ],
            },
            {
                title: "Ventajas de una hipoteca del 90%",
                list: [
                    "Menor ahorro inicial necesario",
                    "Acceso más rápido a la vivienda",
                    "Posibilidad de financiar antes la compra",
                    "Estudio personalizado según tu perfil",
                    "Comparación entre diferentes bancos para mejorar condiciones",
                ],
            },
            {
                title: "¿Cuánto dinero necesitas ahorrar?",
                paragraphs: [
                    "Aunque la hipoteca financie el 90%, normalmente deberás aportar el 10% restante del precio de la vivienda más los gastos de compraventa (notaría, impuestos, registro, gestoría, etc.).",
                    "Por ejemplo, en una vivienda de 200.000 €, necesitarías aproximadamente 20.000 € más gastos.",
                ],
            },
        ],
        ctaTitle: "Te ayudamos a conseguir tu hipoteca",
        cta: "Solicita tu estudio gratuito y sin compromiso. Te ayudamos a saber si puedes acceder a tu hipoteca 90%.",
    },
    "hipoteca-joven": {
        icon: "Sparkles",
        title: "Hipoteca Joven",
        subtitle: "Compra tu primera vivienda con mejores condiciones",
        intro: [
            "La hipoteca joven está pensada para facilitar el acceso a la vivienda a personas jóvenes que quieren comprar su primera casa pero necesitan condiciones más flexibles de financiación.",
            "En Keypoteca te ayudamos a encontrar hipotecas para jóvenes adaptadas a tu perfil, comparando opciones entre diferentes bancos para que puedas acceder a mejores condiciones y dar el paso hacia tu independencia.",
        ],
        sections: [
            {
                title: "¿Qué es una hipoteca joven?",
                paragraphs: [
                    "Una hipoteca joven es un tipo de financiación dirigida a personas jóvenes que suelen tener menos ahorro acumulado y buscan facilitar la compra de su primera vivienda.",
                    "Aunque las condiciones pueden variar según la entidad, este tipo de hipotecas suele ofrecer mayor flexibilidad en la financiación, tipos de interés competitivos o requisitos adaptados al perfil del solicitante.",
                ],
            },
            {
                title: "¿Para quién es una hipoteca joven?",
                paragraphs: ["Este producto está pensado para:"],
                list: [
                    "Jóvenes que compran su primera vivienda",
                    "Personas con ingresos estables pero poco ahorro",
                    "Menores de una edad aproximada (según banco)",
                    "Profesionales que empiezan su carrera laboral",
                    "Parejas jóvenes que quieren independizarse",
                ],
            },
            {
                title: "Ventajas de la hipoteca joven",
                list: [
                    "Mayor facilidad de acceso a financiación",
                    "Condiciones adaptadas a perfiles jóvenes",
                    "Posibilidad de menor entrada inicial en algunos casos",
                    "Cuotas ajustadas a la capacidad de pago",
                    "Ayudas o condiciones especiales según entidad",
                ],
            },
            {
                title: "¿Cuánto puedes financiar?",
                paragraphs: [
                    "La financiación dependerá de tu perfil y del banco, pero en muchos casos puede llegar hasta porcentajes elevados del valor de la vivienda, especialmente si tienes buena estabilidad laboral y capacidad de pago.",
                ],
            },
        ],
        ctaTitle: "Consigue tu hipoteca joven con Keypoteca",
        cta: "En Keypoteca analizamos tu perfil y te ayudamos a encontrar la mejor hipoteca joven para ti.",
    },
    "capital-privado": {
        icon: "Landmark",
        title: "Capital privado hipotecario",
        subtitle: "Financiación alternativa para comprar o refinanciar tu vivienda",
        intro: [
            "El capital privado es una alternativa de financiación hipotecaria pensada para personas que no pueden acceder a un préstamo bancario tradicional o necesitan una solución más rápida y flexible.",
            "En Keypoteca te ayudamos a encontrar opciones de financiación con capital privado adaptadas a tu situación, analizando tu caso de forma personalizada para darte una solución viable según tu perfil.",
        ],
        sections: [
            {
                title: "¿Qué es el capital privado?",
                paragraphs: [
                    "El capital privado es un tipo de financiación en el que el préstamo no lo concede un banco, sino inversores o entidades privadas.",
                    "Este tipo de financiación suele ser más flexible en los requisitos, aunque también puede tener condiciones diferentes a las de una hipoteca bancaria tradicional.",
                    "Se utiliza principalmente como solución temporal o alternativa cuando el banco no aprueba la operación.",
                ],
            },
            {
                title: "¿Cuándo se utiliza el capital privado?",
                paragraphs: ["El capital privado puede ser una opción en situaciones como:"],
                list: [
                    "Rechazo de hipoteca bancaria",
                    "Necesidad urgente de financiación",
                    "Compra de vivienda con dificultades bancarias",
                    "Reunificación o cancelación de deudas",
                    "Inmuebles con situaciones complejas",
                ],
            },
            {
                title: "Ventajas del capital privado",
                list: [
                    "Mayor rapidez en la aprobación",
                    "Menos requisitos bancarios",
                    "Posibilidad de financiación en situaciones complejas",
                    "Solución para operaciones urgentes",
                    "Flexibilidad en el estudio del caso",
                ],
            },
            {
                title: "Aspectos a tener en cuenta",
                paragraphs: ["El capital privado no funciona igual que una hipoteca bancaria tradicional. Es importante tener en cuenta que:"],
                list: [
                    "Puede tener tipos de interés más elevados",
                    "Suele ser una solución a corto o medio plazo",
                    "Requiere un análisis detallado de la operación",
                    "Es clave tener una estrategia de salida o refinanciación",
                ],
            },
            {
                title: "¿Para quién es el capital privado?",
                paragraphs: ["Este tipo de financiación está orientado a:"],
                list: [
                    "Personas que no pueden acceder a un banco",
                    "Compradores con urgencia de financiación",
                    "Propietarios con problemas financieros",
                    "Inversores inmobiliarios",
                    "Casos complejos que requieren soluciones flexibles",
                ],
            },
        ],
        cta: "Solicita un estudio personalizado y descubre si el capital privado puede ser una opción para ti.",
    },
    "necesitas-liquidez": {
        icon: "HandCoins",
        title: "¿Necesitas liquidez?",
        subtitle: "Accede a dinero para lo que necesites.",
        intro: [
            "Si ya tienes una hipoteca sobre tu vivienda habitual y necesitas dinero extra, puedes ampliarla para conseguir liquidez inmediata y utilizarla para lo que tú necesites: reformar tu casa, pagar estudios, emprender un negocio, cubrir gastos imprevistos o simplemente mejorar tu situación financiera.",
            "Ampliar o hipotecar tu primera vivienda, es una alternativa más económica y flexible que solicitar un préstamo personal, ya que se aplica el tipo de interés hipotecario, que suele ser mucho más bajo.",
        ],
        sections: [
            {
                title: "¿Para qué puedes usar la liquidez?",
                list: [
                    "Reformas o mejoras en tu vivienda",
                    "Estudios o formación para ti o tus hijos",
                    "Iniciar un proyecto profesional o inversión",
                    "Cancelar deudas con intereses más altos",
                    "Gastos médicos, imprevistos o cualquier necesidad personal",
                ],
            },
            {
                title: "Ventajas de ampliar tu hipoteca",
                list: [
                    "Liquidez inmediata con mejores condiciones que un préstamo personal",
                    "Tipo de interés más bajo",
                    "Una sola cuota mensual, más fácil de controlar",
                    "Mayor plazo de devolución, con cuotas más ajustadas",
                ],
                closing: "En Keypoteca te ayudamos a valorar si esta opción es viable para ti, negociamos con los bancos por ti y te acompañamos durante todo el proceso.",
            },
        ],
        ctaTitle: "Amplía tu hipoteca y obtén liquidez para lo que necesites",
        cta: "Solicita tu estudio gratuito y sin compromiso. Te ayudamos a saber si puedes acceder a liquidez inmediata.",
    },
};
